// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.profile-title {
  color: #003366;
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: bold;
}

.profile-paper {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.profile-avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-avatar {
  width: 150px;
  height: 150px;
  border: 2px solid #003366;
}

.profile-avatar img {
  border-radius: 50%;
}

.profile-avatar:hover {
  border-color: #0055a5;
}

.profile-avatar:active {
  border-color: #002244;
}

.profile-avatar:focus {
  border-color: #0077cc;
}

.profile-avatar:disabled {
  border-color: #cccccc;
}

.profile-avatar:checked,
.profile-avatar:valid,
.profile-avatar:in-range,
.profile-avatar:optional,
.profile-avatar:read-write,
.profile-avatar:default {
  border-color: #00cc00;
}

.profile-avatar:invalid,
.profile-avatar:out-of-range,
.profile-avatar:required {
  border-color: #cc0000;
}

.profile-avatar:indeterminate,
.profile-avatar:read-only {
  border-color: #cccccc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile/ProfilePage.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB","sourcesContent":[".profile-container {\n  background-color: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.profile-title {\n  color: #003366;\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.profile-paper {\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.profile-avatar-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.profile-avatar {\n  width: 150px;\n  height: 150px;\n  border: 2px solid #003366;\n}\n\n.profile-avatar img {\n  border-radius: 50%;\n}\n\n.profile-avatar:hover {\n  border-color: #0055a5;\n}\n\n.profile-avatar:active {\n  border-color: #002244;\n}\n\n.profile-avatar:focus {\n  border-color: #0077cc;\n}\n\n.profile-avatar:disabled {\n  border-color: #cccccc;\n}\n\n.profile-avatar:checked,\n.profile-avatar:valid,\n.profile-avatar:in-range,\n.profile-avatar:optional,\n.profile-avatar:read-write,\n.profile-avatar:default {\n  border-color: #00cc00;\n}\n\n.profile-avatar:invalid,\n.profile-avatar:out-of-range,\n.profile-avatar:required {\n  border-color: #cc0000;\n}\n\n.profile-avatar:indeterminate,\n.profile-avatar:read-only {\n  border-color: #cccccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
